import {HttpErrorResponse} from '@angular/common/http';
import {ErrorHandler} from '@angular/core';

export function isPasswordChangeRequiredHttpError(error: unknown): boolean {
  const originalError = typeof error === 'object' && error !== null && 'ngOriginalError' in error
    ? error.ngOriginalError
    : error;

  if (typeof originalError !== 'object' || originalError === null) return false;

  // Sentry normalizes console arguments into plain objects before calling beforeSendLog.
  const isHttpError = originalError instanceof HttpErrorResponse ||
    ('name' in originalError && originalError.name === 'HttpErrorResponse' &&
      'status' in originalError && typeof originalError.status === 'number');
  if (!isHttpError || !('error' in originalError)) return false;

  const responseBody = originalError.error;
  return typeof responseBody === 'object' && responseBody !== null &&
    'reason' in responseBody && responseBody.reason === 'PASSWORD_CHANGE_REQUIRED';
}

export function isExpectedHttpError(error: unknown): boolean {
  const originalError = typeof error === 'object' && error !== null && 'ngOriginalError' in error
    ? error.ngOriginalError
    : error;
  const isHttpError = originalError instanceof HttpErrorResponse ||
    (typeof originalError === 'object' && originalError !== null &&
      'name' in originalError && originalError.name === 'HttpErrorResponse' &&
      'status' in originalError && typeof originalError.status === 'number');
  if (!isHttpError) return false;

  return isPasswordChangeRequiredHttpError(originalError) ||
    (originalError.status === 0 || originalError.status === 422 || originalError.status === 423);
}

export function isUnsupportedFirebaseMessagingError(error: unknown): boolean {
  const originalError = typeof error === 'object' && error !== null && 'ngOriginalError' in error
    ? error.ngOriginalError
    : error;

  return typeof originalError === 'object' && originalError !== null &&
    'name' in originalError && originalError.name === 'FirebaseError' &&
    'code' in originalError && originalError.code === 'messaging/unsupported-browser';
}

export function validationAwareErrorHandler(delegate: ErrorHandler): ErrorHandler {
  return {
    handleError(error: unknown): void {
      if (isExpectedHttpError(error)) return;
      delegate.handleError(error);
    },
  };
}
